// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               unknown
// source: types/type_tx_out.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "../../binary";
import { DeepPartial, Exact, isSet } from "../../helpers";
import { Coin } from "../common/common";

export const protobufPackage = "types";

export interface TxOutItem {
  chain: string;
  toAddress: string;
  vaultPubKey: string;
  coin: Coin | undefined;
  memo: string;
  maxGas: Coin[];
  gasRate: number;
  inHash: string;
  outHash: string;
  moduleName: string;
  aggregator: string;
  aggregatorTargetAsset: string;
  aggregatorTargetLimit: string;
  cloutSpent: string;
}

export interface TxOut {
  height: number;
  txArray: TxOutItem[];
}

function createBaseTxOutItem(): TxOutItem {
  return {
    chain: "",
    toAddress: "",
    vaultPubKey: "",
    coin: undefined,
    memo: "",
    maxGas: [],
    gasRate: 0,
    inHash: "",
    outHash: "",
    moduleName: "",
    aggregator: "",
    aggregatorTargetAsset: "",
    aggregatorTargetLimit: "",
    cloutSpent: "",
  };
}

export const TxOutItem = {
  encode(
    message: TxOutItem,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.chain !== "") {
      writer.uint32(10).string(message.chain);
    }
    if (message.toAddress !== "") {
      writer.uint32(18).string(message.toAddress);
    }
    if (message.vaultPubKey !== "") {
      writer.uint32(26).string(message.vaultPubKey);
    }
    if (message.coin !== undefined) {
      Coin.encode(message.coin, writer.uint32(34).fork()).ldelim();
    }
    if (message.memo !== "") {
      writer.uint32(42).string(message.memo);
    }
    for (const v of message.maxGas) {
      Coin.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    if (message.gasRate !== 0) {
      writer.uint32(56).int64(message.gasRate);
    }
    if (message.inHash !== "") {
      writer.uint32(66).string(message.inHash);
    }
    if (message.outHash !== "") {
      writer.uint32(74).string(message.outHash);
    }
    if (message.moduleName !== "") {
      writer.uint32(82).string(message.moduleName);
    }
    if (message.aggregator !== "") {
      writer.uint32(90).string(message.aggregator);
    }
    if (message.aggregatorTargetAsset !== "") {
      writer.uint32(98).string(message.aggregatorTargetAsset);
    }
    if (message.aggregatorTargetLimit !== "") {
      writer.uint32(106).string(message.aggregatorTargetLimit);
    }
    if (message.cloutSpent !== "") {
      writer.uint32(114).string(message.cloutSpent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TxOutItem {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxOutItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.chain = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.toAddress = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.vaultPubKey = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.coin = Coin.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.memo = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.maxGas.push(Coin.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.gasRate = Number(reader.int64());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.inHash = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.outHash = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.moduleName = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.aggregator = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.aggregatorTargetAsset = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.aggregatorTargetLimit = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.cloutSpent = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TxOutItem {
    return {
      chain: isSet(object.chain) ? globalThis.String(object.chain) : "",
      toAddress: isSet(object.toAddress)
        ? globalThis.String(object.toAddress)
        : "",
      vaultPubKey: isSet(object.vaultPubKey)
        ? globalThis.String(object.vaultPubKey)
        : "",
      coin: isSet(object.coin) ? Coin.fromJSON(object.coin) : undefined,
      memo: isSet(object.memo) ? globalThis.String(object.memo) : "",
      maxGas: globalThis.Array.isArray(object?.maxGas)
        ? object.maxGas.map((e: any) => Coin.fromJSON(e))
        : [],
      gasRate: isSet(object.gasRate) ? globalThis.Number(object.gasRate) : 0,
      inHash: isSet(object.inHash) ? globalThis.String(object.inHash) : "",
      outHash: isSet(object.outHash) ? globalThis.String(object.outHash) : "",
      moduleName: isSet(object["-"]) ? globalThis.String(object["-"]) : "",
      aggregator: isSet(object.aggregator)
        ? globalThis.String(object.aggregator)
        : "",
      aggregatorTargetAsset: isSet(object.aggregatorTargetAsset)
        ? globalThis.String(object.aggregatorTargetAsset)
        : "",
      aggregatorTargetLimit: isSet(object.aggregatorTargetLimit)
        ? globalThis.String(object.aggregatorTargetLimit)
        : "",
      cloutSpent: isSet(object.cloutSpent)
        ? globalThis.String(object.cloutSpent)
        : "",
    };
  },

  toJSON(message: TxOutItem): unknown {
    const obj: any = {};
    if (message.chain !== "") {
      obj.chain = message.chain;
    }
    if (message.toAddress !== "") {
      obj.toAddress = message.toAddress;
    }
    if (message.vaultPubKey !== "") {
      obj.vaultPubKey = message.vaultPubKey;
    }
    if (message.coin !== undefined) {
      obj.coin = Coin.toJSON(message.coin);
    }
    if (message.memo !== "") {
      obj.memo = message.memo;
    }
    if (message.maxGas?.length) {
      obj.maxGas = message.maxGas.map((e) => Coin.toJSON(e));
    }
    if (message.gasRate !== 0) {
      obj.gasRate = Math.round(message.gasRate);
    }
    if (message.inHash !== "") {
      obj.inHash = message.inHash;
    }
    if (message.outHash !== "") {
      obj.outHash = message.outHash;
    }
    if (message.moduleName !== "") {
      obj["-"] = message.moduleName;
    }
    if (message.aggregator !== "") {
      obj.aggregator = message.aggregator;
    }
    if (message.aggregatorTargetAsset !== "") {
      obj.aggregatorTargetAsset = message.aggregatorTargetAsset;
    }
    if (message.aggregatorTargetLimit !== "") {
      obj.aggregatorTargetLimit = message.aggregatorTargetLimit;
    }
    if (message.cloutSpent !== "") {
      obj.cloutSpent = message.cloutSpent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TxOutItem>, I>>(base?: I): TxOutItem {
    return TxOutItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TxOutItem>, I>>(
    object: I
  ): TxOutItem {
    const message = createBaseTxOutItem();
    message.chain = object.chain ?? "";
    message.toAddress = object.toAddress ?? "";
    message.vaultPubKey = object.vaultPubKey ?? "";
    message.coin =
      object.coin !== undefined && object.coin !== null
        ? Coin.fromPartial(object.coin)
        : undefined;
    message.memo = object.memo ?? "";
    message.maxGas = object.maxGas?.map((e) => Coin.fromPartial(e)) || [];
    message.gasRate = object.gasRate ?? 0;
    message.inHash = object.inHash ?? "";
    message.outHash = object.outHash ?? "";
    message.moduleName = object.moduleName ?? "";
    message.aggregator = object.aggregator ?? "";
    message.aggregatorTargetAsset = object.aggregatorTargetAsset ?? "";
    message.aggregatorTargetLimit = object.aggregatorTargetLimit ?? "";
    message.cloutSpent = object.cloutSpent ?? "";
    return message;
  },
};

function createBaseTxOut(): TxOut {
  return { height: 0, txArray: [] };
}

export const TxOut = {
  encode(
    message: TxOut,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.height !== 0) {
      writer.uint32(8).int64(message.height);
    }
    for (const v of message.txArray) {
      TxOutItem.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TxOut {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxOut();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.height = Number(reader.int64());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.txArray.push(TxOutItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TxOut {
    return {
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      txArray: globalThis.Array.isArray(object?.txArray)
        ? object.txArray.map((e: any) => TxOutItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TxOut): unknown {
    const obj: any = {};
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    if (message.txArray?.length) {
      obj.txArray = message.txArray.map((e) => TxOutItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TxOut>, I>>(base?: I): TxOut {
    return TxOut.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TxOut>, I>>(object: I): TxOut {
    const message = createBaseTxOut();
    message.height = object.height ?? 0;
    message.txArray =
      object.txArray?.map((e) => TxOutItem.fromPartial(e)) || [];
    return message;
  },
};
